import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

// Scroll-triggered reveal wrapper. Keeps motion config in one place.
export const Reveal = ({ children, className, delay = 0, y = 24, as = "div", ...rest }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={cn(className)}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};
